import { render, staticRenderFns } from "./PriceDevelopmentInLocalCurrencyComparedToAveragePrice.vue?vue&type=template&id=9c395c48&"
import script from "./PriceDevelopmentInLocalCurrencyComparedToAveragePrice.vue?vue&type=script&lang=js&"
export * from "./PriceDevelopmentInLocalCurrencyComparedToAveragePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports